// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ca79a985a6bae169a015","453":"4c25deb1eb75ccdff209"}[chunkId] + ".js";
};